// src/services/phraseConfig.ts

import { apiService } from "./axios";

export interface PhraseConfig {
  interest: string[];
  disinterest: string[];
  blocklist: string[];
}

export interface PhraseConfigResponse {
  status: string;
  data: PhraseConfig;
  message: string;
}

export interface UpdatePhraseConfigRequest {
  interest: string[];
  disinterest: string[];
  blocklist: string[];
}

export const phraseConfigService = {
  /**
   * Obtém a configuração de frases da empresa
   */
  async getPhraseConfig(companyId: string): Promise<PhraseConfig> {
    const response = await apiService.get(
      `/companies/${companyId}/phrase-config`,
    );
    if (response.status === "success") {
      return response.data as PhraseConfig;
    }
    throw new Error(response.message || "Erro ao obter configuração de frases");
  },

  /**
   * Atualiza a configuração de frases da empresa
   */
  async updatePhraseConfig(
    companyId: string,
    config: UpdatePhraseConfigRequest,
  ): Promise<{ status: string; message: string }> {
    const response = await apiService.put(
      `/companies/${companyId}/phrase-config`,
      config,
    );
    if (response.status === "success") {
      return response.data as { status: string; message: string };
    }
    throw new Error(
      response.message || "Erro ao atualizar configuração de frases",
    );
  },
};
